export enum AccountType {
  MASTER = "MASTER",
  MANDATE = "MANDATE",
  DCA = "DCA",
  EXCHANGE = "EXCHANGE"
}

export enum DcaStatus {
  ACTIVE = "Active",
  STOPPED = "Stopped",
  EDITING = "Editing",
  COMPLETED = "Completed"
}
